module.exports = __webpack_public_path__ + "static/media/DatePickerRight.20147234.svg";